<template>
  <div class="band" v-loading="lo">
    <!--div style="font-size: 12px;color:#8996a0">
      <i class="feather-map-pin"></i> <span v-if="geo">{{ geo.lat }} - {{ geo.lng }}</span><span style="color: red" v-if="!geo">Konum izni vermediniz</span>
    </div-->
    <div v-if="!lo" style="font-size: 12px;color:#8996a0">
      {{ Liste.Tarih }}
    </div>
    <DigitalClock class="Saat" :blink="false" :displaySeconds="true"></DigitalClock>

    <div class="Piyasa" v-if="!lo">
      <span class="tx-IBM" v-if="Liste" style="margin-right: 20px;font-size: 12px"> <b>$</b>
        {{ Liste.Dolar.Alis }}
      </span>
      <span class="tx-IBM" v-if="Liste" style="font-size: 12px"><b>€</b>
        {{ Liste.Euro.Alis }}
      </span>
    </div>
    <div class="HavaDurumu" v-if="!lo">
      <img :src="'http://openweathermap.org/img/w/'+HavaDetay.weather[0].icon+'.png'">
      <span class="description">{{ HavaDetay.weather[0].description }}</span>
      <span class="temp">{{ HavaDetay.main.temp }}°</span>
    </div>
    <div class="haber" v-if="!lo">
      <a href="https://www.aa.com.tr/" target="_blank"> <img width="15px"
                                                             src="https://cdnassets.aa.com.tr/assets/images/aalogomin.png"></a>
      <el-carousel height="62px" direction="vertical" :autoplay="true" :interval="4000">
        <el-carousel-item v-for="(h,index) in Haber" :key="index">
          <a :href="h.link" target="_blank"><b>{{ h.title }}</b></a>
        </el-carousel-item>
      </el-carousel>
    </div>

  </div>
</template>
<script>

import DigitalClock from "vue-digital-clock"


export default {
  components: {DigitalClock},
  data() {
    return {
      geo: null,
      Liste: null,
      HavaDetay: null,
      Haber: null,
      Tarih: null,
      lo: true
    }
  },
  methods: {
    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'panel/band'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.HavaDetay = response.Hava;
            this.Haber = response.Haber;
            this.Tarih = response.Tarih;
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    }
  },
  created() {
    this.SayfaYukle();
    this.$getLocation()
      .then(coordinates => {
        this.geo = coordinates;
      });
  }
}
</script>

<style>
.band {
  position: relative;
  padding: 10px;
  border-radius: 3px;
  height: 200px;
  border: 1px solid #dcdfe6;
  margin-left: 10px;
  text-align: center;
}

.Saat {
  font-weight: bold;
  font-size: 20px;
  color: #8996a0;

}

.el-carousel__item a {
  color: #8996a0;
  font-size: 12px;
  opacity: 1;
  margin: 0;
  line-height: 10px;
  font-weight: 500;
  text-align: left;
}

.el-carousel__indicators--vertical {
  display: none !important;
}

.haber {
  color: #333;
  font-size: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  padding: 5px;
  margin-top: 5px;
  position: relative;
  text-align: left;
}

.haber img {
  width: 15px;
  position: absolute;
  right: 5px;
  bottom: 5px;
  opacity: 0.3;
}

.haber .el-carousel {
  margin-top: 2px;
}

</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelBand.vue